import { useEffect } from 'react';

/** #2133 デザイン: ブラウザのタブの名前をロールの名前に合わせる。 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
